// extracted by mini-css-extract-plugin
module.exports = {"content":"k_1aEyV","inner":"k_1mkro","wrap":"k_3HtCj","subtitle":"k_1JGd1","list":"k_1q596","buttons":"k_jZ2mk"};